import type { FaireProductEntity } from "../../entity_types/product";

export const atc_nf_chunks_11: FaireProductEntity = {
  token: "atc_nf_chunks_11",
  type: "product",
  name: "Baby Dolly Claw Charmed Call Me",
  brandName: "Chunks",
  imageUrl:
    "https://cdn.shopify.com/s/files/1/0510/2698/5143/products/Claw-BabyDolly-Pink-Charm-Cellphone-WBG-web-1.jpg?v=1677205329",
  priceDollars: 7.95,
  msrpDollars: 16,
  description: "ATC migration seed product",
  tags: ["hair", "accessories", "chunks"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
